import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import moment from "moment";
import nophoto from "../../../Images/noImage.jpg";
import { useDispatch, useSelector } from "react-redux";
import { fetchRemarksOnProperty } from "../../../Stores/Slices/SidebarSlices";
import Swal from "sweetalert2";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function UserRemarks() {
  const [allData, setAllData] = useState([]);
  const dispatch = useDispatch();
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

  const fetchAllData = async () => {
    try {
      const response = await HomeService.getRemarksOnProperties();

      let formattedData = response?.data
        .filter((item) => item.Property !== null)
        .map((item, index) => ({
          ...item,
          sln: index + 1,
        }));

      if (userCity) {
        formattedData = formattedData.filter(
          (item) => item?.Property?.city?._id === userCity,
        );
      }

      console.log("WER30", formattedData);
      setAllData(formattedData || []);
    } catch (error) {
      console.error("Error fetching allData:", error);
      toast.error("Failed to fetch allData.");
    }
  };

  const toggleStatus = async (id) => {
    try {
      const response = await HomeService.readRemark(id);
      dispatch(fetchRemarksOnProperty());
      fetchAllData();

      // toast.success(`Property status updated to ${newStatus}!`);
    } catch (error) {
      // toast.error("Failed to update property status.");
      console.error("Error updating status:", error);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Deleting Remarks...",
      text: "Are you sure you want to delete this Remarks record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "No, not sure!",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteRemarks(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Remarks record has been deleted.", "success");
          dispatch(fetchRemarksOnProperty());
          fetchAllData();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Remarks record.", "error");
      }
    }
  };

  // Define columns for the data table
  const columns = [
    {
      name: "SL#",
      selector: (row) =>
        !row.readByAdmin ? <strong>{row.sln}</strong> : <>{row.sln}</>,
    },
    {
      name: "Date",
      selector: (row) => moment(row?.createdOn).format("DD-MM-YYYY"),
      sortable: true,
    },

    {
      name: "Photo",
      cell: (row) => (
        <>
          <img
            src={row?.Property?.images[0] || nophoto}
            alt="..."
            style={{ width: "100%", padding: "5px" }}
          />
        </>
      ),
    },
    { name: "Apartment", selector: (row) => row?.Property?.aptName },
    { name: "City", selector: (row) => row?.Property?.city?.name },
    { name: "Owner", selector: (row) => row?.Property?.ownerName },
    { name: "Remarked by", selector: (row) => row?.User?.fullName },
    {
      name: "Remarks",
      selector: (row) =>
        !row.readByAdmin ? (
          <strong>{row?.remarks}</strong>
        ) : (
          <>{row?.remarks}</>
        ),
      wrap: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          className={`btn btn-${row.readByAdmin ? "success" : "danger"}`}
          onClick={() => toggleStatus(row._id, row.readByAdmin)}
        >
          {row.readByAdmin ? "Read" : "Mark as read"}
        </button>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span title="Delete" onClick={() => handleDelete(row?._id)}>
            <i
              className="fa-solid fa-trash"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: " red",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
      //   textAlign: "center",
    },
  ];
  return (
    <div className="main_wrap">
      <div className="container-fluid" id="edit-section">
        <div className="mt-5">
          <h2 className="text-center" style={headLineStyle}>
            Remarks
          </h2>
          <hr />

          <DataTable columns={columns} data={allData} pagination />
        </div>
      </div>
    </div>
  );
}

export default UserRemarks;
